"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = exports.meCall = void 0;
const react_1 = require("react");
const abortable_fetch_1 = require("../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
/**
 * Me call
 *
 * @param meUrl Url of Me service
 */
function meCall(meUrl) {
    return abortable_fetch_1.abortableFetch(meUrl, {
        method: 'GET',
    });
}
exports.meCall = meCall;
function useUser(meUrl, logoutUrl, checkPermission) {
    const [user, setUser] = react_1.useState(undefined);
    const reload = event_callback_hook_1.useEventCallback(async () => {
        const response = meCall(meUrl);
        try {
            const user = (await response.json());
            setUser(user);
        }
        catch (e) {
            setUser(undefined);
        }
    });
    const hasPermission = react_1.useCallback((permission, state) => {
        var _a;
        if (user !== undefined) {
            if (checkPermission) {
                return checkPermission(user, permission, state);
            }
            else {
                return (((_a = user.authorities) === null || _a === void 0 ? void 0 : _a.find((a) => a.authority === permission)) !==
                    undefined);
            }
        }
        else {
            return false;
        }
    }, [checkPermission, user]);
    const isLogedIn = event_callback_hook_1.useEventCallback(() => {
        return user !== undefined;
    });
    const logout = event_callback_hook_1.useEventCallback(async (automatic = false) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${logoutUrl}${automatic ? '?automatic' : ''}`;
        document.body.appendChild(form);
        form.submit();
    });
    const logoutWithoutRedirect = event_callback_hook_1.useEventCallback(async () => {
        const response = await abortable_fetch_1.abortableFetch(`${logoutUrl}`, {
            method: 'POST',
        });
        return await response.none();
    });
    const context = react_1.useMemo(() => ({
        user,
        hasPermission,
        isLogedIn,
        reload,
        logout,
        logoutWithoutRedirect,
    }), [user, hasPermission, isLogedIn, reload, logout, logoutWithoutRedirect]);
    return { user, context };
}
exports.useUser = useUser;
//# sourceMappingURL=user-hook.js.map